<template>
	<div>
		<div class="row">
			<div class="col-md-12 mb-2">
				<h4>BRIGHT STORE LIST</h4>
			</div>

			<div class="col-md-12">
				<el-card shadow="never" class="box-card col-md-12 mb-1" :body-style="{ paddingLeft: '6px', paddingRight: '6px' }">
					<div slot="header" class="clearfix" v-if="false">
						<span><strong>Store List</strong></span>
					</div>

					<div>
						<el-collapse>
                            <el-collapse-item>
                                <template slot="title">
                                    <span style="color:#606266;font-size:14px;"><i class="header-icon el-icon-search"></i>&nbsp;&nbsp;&nbsp;Filter</span>
                                </template>
                                <el-form label-position="top" label-width="100px" class="ml-4">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <el-form-item label="Store:">
												<el-select v-model="branchid1" clearable filterable placeholder="Select Store" size="medium" style="width:100%;" name="branchid">
													<el-option v-for="item3 in store.list" :key="item3.BranchId" :label="item3.BPOSBranchName" :value="item3.BranchId">
													</el-option>
												</el-select>
											</el-form-item>
                                        </div>
										<div class="col-md-3">
                                            <el-form-item label="Skema:">
												<el-select v-model="skema" clearable filterable placeholder="Select Skema" size="medium" style="width:100%;" name="skema">
													<el-option v-for="item3 in options.skema" :key="item3.Skema" :label="item3.Skema" :value="item3.Skema">
													</el-option>
												</el-select>
											</el-form-item>
                                        </div>
										<div class="col-md-3">
                                            <el-form-item label="Flag:">
												<el-select v-model="flag" clearable filterable placeholder="Select Flag" size="medium" style="width:100%;" name="flag">
													<el-option v-for="item3 in options.flag" :key="item3.Flag" :label="item3.Flag" :value="item3.Flag">
													</el-option>
												</el-select>
											</el-form-item>
                                        </div>

                                        <div class="col-md-6">
                                            <el-form-item label="Area">
                                                <el-radio-group v-model="area" size="small" name="area">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.area" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

										<div class="col-md-6">
                                            <el-form-item label="Region">
                                                <el-radio-group v-model="region" size="small" name="region">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.region" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>

                                        <div class="col-md-6">
                                            <el-form-item label="Status">
                                                <el-radio-group v-model="status" size="small" name="status">
                                                    <el-radio-button :label="item5.value" v-for="(item5, index5) in options.status" :key="item5.value+'_'+index5" style="margin-left:0px;">{{item5.name}}</el-radio-button>
                                                </el-radio-group>
                                            </el-form-item>
                                        </div>
                                    </div>

									<div class="row">
										<div class="col-md-6">
											<el-button type="primary" size="medium" :loading="loading.table" @click="applyFilter" style="width:100%;">Apply Filter</el-button>
										</div>
									</div>

                                </el-form>
                            </el-collapse-item>
                        </el-collapse>
					</div>

					<div class="row mt-2 mb-2">
                        <div class="col-md-6">
                            <!--<input type="checkbox" v-model="showmap"> Show Map-->
                            <el-checkbox v-model="showmap">Show Map</el-checkbox>
                        </div>
                    </div>

                    <PetaGmap v-if="showmap" :zoom="this.zoom" :centeringMap="centeringMap" :stationListMap="stationListMap" @pilihStationDariGmap="pilihStationDariGmap"/>


                    <div class="row">
                        <div class="col-md-12 mx-auto">
                            <div class="h-100 d-flex align-items-center justify-content-center">
                                <ReportResultTable reportname="StationList" :reportdata="reportdata" :reporturl="urlRequestParams" select_url="/plant?station=" idcol="BranchId" :loading="loading.table"/>

                            </div>
                        </div>
                    </div>

				</el-card>
			</div>
		</div>
	</div>
</template>

<script>

import Bright from '@/components/page/Bright.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import ReportResultTable from '@/views/pages/ReportResultTable2.vue'
import { AxiosWithJar, Config} from '@/utility.js'
import Loader from '@/components/loader/Loader.vue'
import PetaGmap from '@/components/map/gmapStore.vue'

export default
{
	extends: Bright,
	components: {
		//ReportParamSelect,
		ReportResultTable,
		PetaGmap,
		//Loader,
	},

	data(){
		return {
			options: {
				area:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
				],
				region:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "1" },
					{ value: "2", name: "2" },
					{ value: "3", name: "3" },
					{ value: "4", name: "4" },
					{ value: "5", name: "5" },
					{ value: "6", name: "6" },
					{ value: "7", name: "7" },
				],
				status:[
					{ value: "", name: "ALL" },
					{ value: "1", name: "ACTIVE" },
					{ value: "0", name: "INACTIVE" },
				],
				skema: [],
				flag: [],
			},
			tabList:[
				{name:'Store'},
			],
			tabIndex: this.$route.query.tab ? this.$route.query.tab : 0,
			area: this.$route.query.area ? this.$route.query.area : '',
			region: this.$route.query.region ? this.$route.query.region : '',
			status: this.$route.query.status ? this.$route.query.status : '',
			branchid1: this.$route.query.branchid ? this.$route.query.branchid : '',
			skema: '',
			flag: '',
			showmap:false,

			reportdata:[],
			stationListMap:[],
			centeringMap:{},
			zoom:5,
		}
	},
	watch:
	{
		//area() { this.resumePilihan() },
		//status(){ this.resumePilihan() },
		reportdata() {
			this.stationListMap = this.reportdata["data"]
			.filter(e=> e.Latitude!==null && e.Longitude!==null)
			.map(item=>Object.assign(item,
				{id:item.BranchId,name:item.BPOSBranchName,lat:Number(item.Latitude.replace(',','.')),lng:Number(item.Longitude.replace(',','.'))}))

				console.log('list: ' + JSON.stringify(this.stationListMap))
		}
	},
    mounted()
    {
        this.$emit('childrenRoute');
		this.loadStoreList()
		this.resumePilihan()
    },
    methods:{
		floatingSearchForm(){
			document.querySelector('.search.form').classList.toggle('floating')
		},
		async resumePilihan(){
			this.urlRequestParams=Config().apiURL
			if (this.tabIndex == 0) this.urlRequestParams+='/bright/storelist?'

			this.urlRequestParams+='&area='+this.area
			this.urlRequestParams+='&region='+this.region
			this.urlRequestParams+='&status='+this.status
			this.urlRequestParams+='&branchid='+this.branchid1
			this.urlRequestParams+='&skema='+this.skema
			this.urlRequestParams+='&flag='+encodeURIComponent(this.flag)

			this.loading.table = true
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.reportdata = response.data;

					if(this.options.skema.length <=0 ) {
						this.skemaList()
						this.flagList()
					}
				})
				.catch(error => {
					//console.log(error)
				})
				.finally(() => {
					this.loading.table = false;
				})
        },
		skemaList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.Skema //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.Keterangan);
				} else {
					groupedData.push({
						branchKey,
						//Keterangan: item.Keterangan,
						Skema: item.Skema
					});
				}
			});

			this.options.skema = groupedData
			//return groupedData;
		},
		flagList() {
			const groupedData = [];
			this.reportdata.data.forEach((item) => {
				const branchKey = item.Flag //`${item.CategoryID} - ${item.BranchName}`;
				const existingGroup = groupedData.find((group) => group.branchKey === branchKey);

				if (existingGroup) {
					//existingGroup.categories.add(item.Keterangan);
				} else {
					groupedData.push({
						branchKey,
						//Keterangan: item.Keterangan,
						Flag: item.Flag
					});
				}
			});

			this.options.flag = groupedData
			//return groupedData;
		},
		applyFilter() {
			this.resumePilihan()
        },
		searchFilterButtonClick(){
			document.querySelector('li.filter').classList.toggle('down')
			var select=document.querySelectorAll('.search.form')
			Array.from(select).map((e)=>{e.classList.toggle('minimize')})
		},

		pilihStationDariGmap(stationId,PlantNo) {
            //this.$router.push({ path: '/plant', query: { plant: PlantNo ,station: stationId } })
            //location.reload()
        },
    }
}
</script>
<style>

.fade-enter-active, .fade-leave-active {
  opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
